import { render, staticRenderFns } from "./Palms.html?vue&type=template&id=7547ff6c&external"
import script from "./Palms.js?vue&type=script&lang=js&external"
export * from "./Palms.js?vue&type=script&lang=js&external"
import style0 from "./Palms.vue?vue&type=style&index=0&id=7547ff6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports